import { render, staticRenderFns } from "./allSalary.vue?vue&type=template&id=5508b6f3&scoped=true&"
import script from "./allSalary.vue?vue&type=script&lang=js&"
export * from "./allSalary.vue?vue&type=script&lang=js&"
import style0 from "./allSalary.vue?vue&type=style&index=0&id=5508b6f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508b6f3",
  null
  
)

export default component.exports